/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Namerequired1Inputs */

const zh_profile_namerequired1 = /** @type {(inputs: Profile_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名不能为空`)
};

const en_profile_namerequired1 = /** @type {(inputs: Profile_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name is required`)
};

const es_profile_namerequired1 = /** @type {(inputs: Profile_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre es obligatorio`)
};

/**
* | output |
* | --- |
* | "Name is required" |
*
* @param {Profile_Namerequired1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_namerequired1 = /** @type {((inputs?: Profile_Namerequired1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Namerequired1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_namerequired1(inputs)
	if (locale === "en") return en_profile_namerequired1(inputs)
	return es_profile_namerequired1(inputs)
});
export { profile_namerequired1 as "profile_nameRequired" }